import React from 'react';
import PropTypes from 'prop-types';
import ReportCardSummary from '../ReportCardSummary/index';
import styles from './GrowthReports.module.css';
import { useAnalytics } from 'hooks/useAnalytics';

const detailsShape = PropTypes.shape({
  listItems: PropTypes.array.isRequired,
}).isRequired;

const footerShape = PropTypes.shape({
  linkDisplayText: PropTypes.string.isRequired,
  linkTarget: PropTypes.string.isRequired,
});

const propTypes = {
  cardDetails: PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    linkTarget: PropTypes.string.isRequired,
    details: detailsShape,
    footer: footerShape,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

function GrowthReportCard({ cardDetails, index }) {
  const { handleItemClick, handleKeystroke } = useAnalytics('rlp-map-reports', 'select-report', cardDetails.identifier);
  const { handleItemClick: handleHelpLinkClick } = useAnalytics(
    'rlp-map-reports',
    'select-report-help-link',
    cardDetails.identifier
  );

  const reportImage = require(`./images/${cardDetails.imageName}.png`);

  const cardFooter = cardDetails.footer ? (
    <a
      className={styles['report-card-footer']}
      target="_blank"
      href={cardDetails.footer.linkTarget}
      onClick={handleHelpLinkClick}
    >
      {cardDetails.footer.linkDisplayText}
    </a>
  ) : null;

  const cardVideo = cardDetails.video ? (
    <a
      className={styles['report-card-footer']}
      target="_blank"
      href={cardDetails.video.linkTarget}
      onClick={handleHelpLinkClick}
    >
      {cardDetails.video.linkDisplayText}
    </a>
  ) : null;

  const reportId = `Report Index ${index}`;

  return (
    <div className={styles['report-card']}>
      <a
        className={styles['report-card-link']}
        href={cardDetails.linkTarget}
        onClick={handleItemClick}
        onKeyUp={handleKeystroke}
        data-report-index={reportId}
      >
        <img className={styles['report-image']} src={reportImage} alt={cardDetails.title} />
        <section role="group" aria-label="report details">
          <ReportCardSummary cardDetails={cardDetails} />
        </section>
      </a>
      <div className={styles['report-card-footer-links']}>
        {cardFooter}
        {cardVideo}
      </div>
    </div>
  );
}

GrowthReportCard.propTypes = propTypes;

export default GrowthReportCard;
